import React, { useEffect } from 'react'
import { Container, IconButton, Skeleton, Stack, Chip, Grid, Typography, Avatar } from '@mui/material'
import placeholder from '../../assets/placeholder_artist.jpg';
import previous from '../../assets/ic_prev.png';
import styles from './Artist.module.css'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { useGetPlaylistQuery } from '../../api/playlistApiSlice';
import TrackRow from '../track/TrackRow';
import parse from 'html-react-parser';


const PlaylistBoard = () => {

    let { id } = useParams()

    const {
        data
    } = useGetPlaylistQuery({id})

    useEffect(() => {
    })

    return data && data !== null
    ? (
            <Grid container spacing={2} sx={{height: '100%'}}>
                <Grid size={{xs: 12, md: 12, lg: 4}} sx={{height: {xs: '30%', md: '30%', lg:'100%'}}}>
                    <Stack 
                        spacing={0} 
                        sx={{
                            height: '100%',
                            borderRadius: '10px',
                            overflow: 'hidden',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundImage: `url(${data.apple_artwork_url ? data.apple_artwork_url.replace("{w}","1300").replace("{h}","1300") : placeholder})`
                            }}
                    >
                        <Container sx={{backdropFilter: 'blur(20px)  brightness(70%)', height: '100%',  paddingTop: '0!important', position: 'relative'}}>
                            <Stack direction="row" alignItems="center">
                                <Link to={'/'}>
                                    <IconButton  sx={{width: '2.2vh', height: '3vh', marginRight: '16px'}}><img alt="previous" height='100%' width='100%' src={previous}/></IconButton>
                                </Link>
                                <h1>{data.apple_name}</h1>  
                            </Stack>
                            <Avatar variant='rounded' alt={data.name} sx={{width: '100%', height: '50%'}} src={data.apple_artwork_url ? data.apple_artwork_url.replace("{w}","1300").replace("{h}","1300") : placeholder} />
                            <p className={styles.head}>{
                                data.apple_description && data.apple_description.length > 0 
                                ? parse(data.apple_description)
                                : data.artist && data.artist.apple_notes.length > 0 
                                    ? data.artist.apple_notes
                                    : '--'
                            }</p>
                            <div className={styles.content}>{
                                data.ranks[data.ranks.length - 1].tracks && data.ranks[data.ranks.length - 1].tracks.length > 0 
                                ? <Typography>{'Temps total : ' + convertMillisToTime(data.ranks[data.ranks.length - 1].tracks.map((track: Track) => track.apple_duration).reduce((a: number, b: number) => a + b))}</Typography>
                                : 'Temps total : --'
                            }</div>
                        </Container>
                    </Stack>
                </Grid>
                <Grid size={{xs: 12, md: 12, lg: 8}} sx={{height: '100%'}}>
                    <Stack spacing={1} sx={{height: '100%'}}>
                        <Stack direction={'row'} sx={{height: '3vh', overflowY: 'hidden', overflowX: 'hidden', margin: '16px 0'}}>
                            <Chip 
                                key={'Tracks'}
                                label={'Tracks'} 
                                sx={{ 
                                    color:'#000',
                                    backgroundColor: '#FFFFFF',
                                    height: '2.6vh',
                                    borderRadius: '1.3vh',
                                    fontFamily: 'Montserrat',
                                    fontSize: '.8rem',
                                    marginRight: '18px',
                                    marginBottom: '18px',
                                    '& span': {padding: '0 18px'}
                                    }}
                            />
                            <Chip 
                                key={'Artistes'}
                                label={'Artistes'} 
                                variant="outlined"
                                sx={{ 
                                    color:'#FFF',
                                    height: '2.6vh',
                                    borderRadius: '1.3vh',
                                    fontFamily: 'Montserrat',
                                    fontSize: '.8rem',
                                    marginRight: '18px',
                                    marginBottom: '18px',
                                    '& span': {padding: '0 18px'}
                                    }}
                            />
                            <Chip 
                                key={'Stats'}
                                label={'Stats'} 
                                variant="outlined"
                                sx={{ 
                                    color:'#FFF',
                                    height: '2.6vh',
                                    borderRadius: '1.3vh',
                                    fontFamily: 'Montserrat',
                                    fontSize: '.8rem',
                                    marginRight: '18px',
                                    marginBottom: '18px',
                                    '& span': {padding: '0 18px'}
                                    }}
                            />
                        </Stack>
                        
                        <Stack sx={{height: '100%', overflowY: 'scroll', overflowX: 'hidden', margin: '16px 0'}}>
                            {
                                data.ranks[data.ranks.length - 1].tracks.map( (track: Track, i: number) => 
                                    <TrackRow key={i} index={i} track={track} color={'#fff'} maxProducers={100} fromAlbum={false} onClick={null} /> 
                                )
                            }
                        </Stack>
                    </Stack>
              </Grid>
            </Grid>
    )
    : <Skeleton/>
}

export default PlaylistBoard

const convertMillisToTime = (timeInMiliseconds: number) => {
    let h,m,s
    h = Math.floor(timeInMiliseconds/1000/60/60)
    m = Math.floor((timeInMiliseconds/1000/60/60 - h)*60)
    s = Math.floor(((timeInMiliseconds/1000/60/60 - h)*60 - m)*60)

    s < 10 ? s = `0${s}`: s = `${s}`
    m < 10 ? m = `0${m}`: m = `${m}`
    h < 10 ? h = `0${h}`: h = `${h}`

    return h === '00'
    ?
        `${m} m ${s} s`
    :
        `${h} h ${m} m ${s} s`

} 